<svg xmlns="http://www.w3.org/2000/svg" width="105" height="177" preserveAspectRatio="none" viewBox="0 0 105 172">
    <defs>
        <linearGradient id="a" x1="50%" x2="50%" y1="41.129%" y2="66.71%">
            <stop offset="0%" stop-color="#D90338"/>
            <stop offset="100%" stop-color="#0069C4"/>
        </linearGradient>
    </defs>
    <g fill="none" fill-rule="evenodd">
        <path fill="url(#a)" d="M0 0h103.373v171.505H0z" transform="translate(1)"/>
        <path stroke="#FFF" stroke-linecap="square" stroke-width="2" d="M3.576 65.087h60.681a6.895 6.895 0 1 1 0 13.79H36.66a6.895 6.895 0 0 0 0 13.79h27.598a6.895 6.895 0 1 1 0 13.79H36.66a6.895 6.895 0 1 0 0 13.79h27.598a6.895 6.895 0 1 1 0 13.791H36.66a6.895 6.895 0 1 0 0 13.79h27.598a6.895 6.895 0 1 1 0 13.79H1.577" opacity=".4"/>
    </g>
</svg>
